// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FatA","label":"styles_label__o-quR"};